export default __webpack_public_path__ + "static/media/Maul of the Raging Earth.f99b252f.jpg";